module.exports = __webpack_public_path__ + "img/hw_logo.ada82ec0.png";